import { Collapsible as BaseCollapsible } from '@base-ui-components/react/collapsible';
import type { ComponentProps } from 'react';

const CollapsibleRoot = BaseCollapsible.Root;

const CollapsibleTrigger = BaseCollapsible.Trigger;

interface CollapsiblePanelProps
  extends ComponentProps<typeof BaseCollapsible.Panel> {
  hiddenUntilFound?: boolean;
}

const CollapsiblePanel = ({
  className,
  children,
  hiddenUntilFound,
  ...props
}: CollapsiblePanelProps) => (
  <BaseCollapsible.Panel
    className={className}
    hiddenUntilFound={hiddenUntilFound}
    {...props}
  >
    {children}
  </BaseCollapsible.Panel>
);

export { CollapsibleRoot, CollapsibleTrigger, CollapsiblePanel };
